export type ColorStateToken =
  | "color.state.hover"
  | "color.state.active"
  | "color.state.focus"
  | "color.state.disabled";

export const COLOR_STATE_TOKENS: ColorStateToken[] = [
  "color.state.hover",
  "color.state.active",
  "color.state.focus",
  "color.state.disabled"
];
